import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import AddpartnerForm from '../../forms/AddPartnerForm';
import AddCategoryForm from '../../forms/AddCategoryForm';
import { CategoryCreate, CategoryGet, CategoryPut, OrgMetaGet, OrgMetaUpdate, OrgUpdate, PartnerGet, SubCategoryByAdminGetDetail, SubCategoryCreate } from '../../../api/orgService';
import AddSubcategoryForm from '../../forms/AddSubcategoryForm';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';
import DashboardCategories from '../Consumer/DashboardCategories.js';
import { useLocation } from 'react-router';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AddOurValuesForm from '../../forms/AddOurValuesForm';
import MetaDataConsumer from '../Consumer/MetaDataConsumer';

const organization = {
  name: "Fountain Africa Trust",
  tagline: "Empowering communities across Kenya.",
  founded: "2018",
  activeCounties: 5,
  logo: "https://picsum.photos/400/250?random=3",
};

const workCategories = ["Education", "Health", "Water & Sanitation"];
const partnersRemote = [
  { name: "UNICEF", logo: "https://picsum.photos/400/250?random=1", link: "https://unicef.org" },
  { name: "Red Cross", logo: "https://picsum.photos/400/250?random=32", link: "https://redcross.org" },
  { name: "WHO", logo: "https://picsum.photos/400/250?random=2", link: "https://who.int" },
];

function OrgAdminRead() {
  
   const location = useLocation()
   const [value, setValue] = useState('one');

  const handleTabOrgChange = (event, newValue) => {
    setValue(newValue);
  };
   const [partners, setPartners ]=useState(partnersRemote)
   const [metadataOrg, setOrgMetadata ]=useState({})
   const [subCatDat, setSubCatData ]=useState(workCategories)
   const { request: partnerGetAll, data:partnerGetAllData, error:partnerGetAllError} = useApi(PartnerGet);
  //  const { request: getAllSubCategories, data: subCategoryData, error: subCategoryError } = useApi(SubCategoryGet);
     const { request: getAllSubCategoriesByAdmin, data: subCategoryByAdminData, error: subCategoryByAdminError } = useApi(SubCategoryByAdminGetDetail);
     const { request: getAllCategories, data:categoryData, error:categoryError, isLoading: dataIsLoading} = useApi(CategoryGet);
     const { request: getAllMetaData, data:orgMetaData, error:orgMetaDataError} = useApi(OrgMetaGet);
     

            useEffect(() => {
             partnerGetAll();
             getAllSubCategoriesByAdmin()
             getAllCategories()
             getAllMetaData(1)
                  // eslint-disable-next-line
            }, []);

            useEffect(()=>{
              if(location?.state?.refresh==="subcategory"){
                getAllSubCategoriesByAdmin()
              }
            },[location?.state])
   
            useEffect(() => {
              // console.log(partnerGetAllData)
               if(orgMetaData?.data){
                setOrgMetadata(orgMetaData?.data)
               }
               // eslint-disable-next-line
            }, [orgMetaData]);

            useEffect(() => {
              console.log(partnerGetAllData)
               if(partnerGetAllData?.data){
                 setPartners(partnerGetAllData?.data?.results)
               }
               // eslint-disable-next-line
            }, [partnerGetAllData]);

            useEffect(() => {
              console.log(subCategoryByAdminData)
               if(subCategoryByAdminData?.data){
                setSubCatData(subCategoryByAdminData?.data)
               }
               // eslint-disable-next-line
            }, [location,subCategoryByAdminData]);

            
             
            //  useEffect(()=>{
              //  if (partnerData?.status===201) {
                 // setAllArticles(partnerData?.data);
                //  toast.success(`${JSON.stringify(partnerData?.data,null,2)}`,{position: "top-center"});
              //  }
             // eslint-disable-next-line
            //  },[partnerData])
         
           
             // useEffect(()=>{
             //     if(location?.state?.refresh==="org"){
             //       partnerCreate();
             //     }
             //   // eslint-disable-next-line
             //   },[location?.state])
           //   useEffect(()=>{
           //     if(partnerData){
                   
           //   }
           // },[partnerData])
           
             useEffect(()=>{
                 if(partnerGetAllError){
                     toast.error(`${JSON.stringify(partnerGetAllError?.response?.data,null,2)}`,{position: "top-center"});
               }
             },[partnerGetAllError])
   
             console.log(metadataOrg)
      return (
        <div className="org-admin-container">
          <h1 className="org-title">Organization Admin Dashboard</h1>
    
          {/* 🏢 Organization Details */}
          <motion.div
            className="org-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="org-header">
              <img src={organization.logo} alt="logo" className="org-logo" />
              <div>
                <h2>{organization.name}</h2>
                <p>{organization.tagline}</p>
              </div>
            </div>
            <div className="org-details">
              <p>🌍 Active in {organization.activeCounties} counties</p>
              <p>💼 Founded: {organization.founded}</p>
            </div>
            <button className="add-btn">+ Add Info</button>
          </motion.div>

          
              {/* 🧭 Work Categories */}
              <motion.div
                className="org-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Box sx={{ width: '100%'}}>
              <Tabs
                value={value}
                onChange={handleTabOrgChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
              >
              <Tab value="one" label="Work Categories">
              
            </Tab>
            <Tab value="two" label="Organisation Branding">
            </Tab>
            <Tab value="three" label="Item Three">

            </Tab>
          </Tabs>
          {
            value=== "one" ? (

              <>
              <h3>Work Categories</h3>
                <DashboardCategories data={subCatDat} allCategories={categoryData?.data?.results} isLoading={dataIsLoading}/>
                {/* <button className="add-btn">+ Add Category</button> */}
                <AddCategoryForm onAddcategory={CategoryPut}/>

                <AddSubcategoryForm onAddSubcategory={SubCategoryCreate}/>
              </>

            ):
            value === "two" ? (
            <>
            <MetaDataConsumer metadata={metadataOrg}/>
            <AddOurValuesForm previousValues={metadataOrg} onAddcategory={OrgMetaUpdate}/>
            </>
            ):
            ""
          }
          </Box>
          </motion.div>
    
          
    
          {/* 🤝 Partners */}
          <motion.div
            className="org-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3>Our Partners</h3>
            <div className="partners-row">
              {partners?.map((p, i) => (
                <a href={p.partner_website} key={i} className="partner-logo" target="_blank" rel="noreferrer">
                  <img src={p.partner_logo} alt={p.partner_name} />
                </a>
              ))}
            </div>
            {/* <button className="add-btn">+ Add Partner</button> */}
            {/* onAddpartner={} */}
            <AddpartnerForm />
          </motion.div>
        </div>
      );
}

export default OrgAdminRead